import { render } from "./wangEditor.vue?vue&type=template&id=2ac89e6e"
import script from "./wangEditor.vue?vue&type=script&lang=js"
export * from "./wangEditor.vue?vue&type=script&lang=js"

import "./wangEditor.vue?vue&type=style&index=0&id=2ac89e6e&lang=css"

import exportComponent from "D:\\AAA_WORK\\os_FMS_sys_projectop\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__